import { BaseModel, RecursivePartial } from '@models/base';
import { getHashHex } from '@models/utils/strings';

export class UrlPreview extends BaseModel {
    id?: string;
    title?: string;
    type?: string;
    image?: string;
    url?: string;
    hash?: string;
    created?: Date;

    constructor(json?: RecursivePartial<UrlPreview>) {
        super(json);
        this.parseUrlPreview(json || {});
    }

    parse(json: RecursivePartial<UrlPreview>): UrlPreview {
        super.parse(json);
        this.parseUrlPreview(json);
        return this;
    }

    private parseUrlPreview(json: RecursivePartial<UrlPreview>): void {
        UrlPreview.assignFields<UrlPreview>(this, json, ['id', 'title', 'type', 'image', 'url', 'hash']);
        this.id ||= this.url;
        this.hash ||= getHashHex(this.url);
        UrlPreview.assignDates(this, json, ['created']);
    }
}
